import { combineReducers } from "redux";
import composerAuthor from "./composerAuthor";
import performer from "./performer";
import song from "./song";
import client from "./client";
import user from "./user";
import agent from "./agent";
import group from "./group";
import clientClassification from "./clientClassification";

const parameterReducer = combineReducers({
    composerAuthor,
    performer,
    song,
    client,
    user,
    agent,
    group,
    clientClassification
});

export default parameterReducer;